import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { layoutReducer } from './layout';
import { userReducer } from './user';
import { registrationReducer } from './registration';
import { certificationsReducer } from './certification';
import { trainingsReducer } from './training';
import { membershipReducer } from './membership';
import { donationReducer } from './donation';
import { workAreaReducer } from './workArea';
import { areaOfExpertiseReducer } from './areaOfExpertise';
import { isNilOrEmpty } from '../util/redux';
import { creditTypeReducer } from './creditType';
import { universityReducer } from './university';
import { membershipResourceReducer } from './membershipResources';
import { certificationResourceReducer } from './certificationResources';
import { announcementReducer } from './announcement';
import { fellowshipServiceTypesReducer } from './fellowshipServiceTypes';
import { preapprovedCreditFeeReducer } from './preapprovedCreditFee';

const reducer = combineReducers({
  layout: layoutReducer,
  user: userReducer,
  registration: registrationReducer,
  certifications: certificationsReducer,
  trainings: trainingsReducer,
  memberships: membershipReducer,
  donations: donationReducer,
  workAreas: workAreaReducer,
  areasOfExpertise: areaOfExpertiseReducer,
  creditTypes: creditTypeReducer,
  universities: universityReducer,
  membershipResources: membershipResourceReducer,
  certificationResources: certificationResourceReducer,
  announcements: announcementReducer,
  fellowshipServiceTypes: fellowshipServiceTypesReducer,
  preapprovedCreditFee: preapprovedCreditFeeReducer,
});

const middleware = [
  // Application middleware

  // Third-party middleware
  thunk,
];

export function configureStore(state) {
  const initialState = isNilOrEmpty(state) ? undefined : state;
  return createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));
}
